export const DEMO_NOTIFICATIONS = [
    {
        id: "demonotify",
        notificationType: "SUCCESS",
        text: "Welcome to the demo version of the application. Here you can get acquainted with most of the functions of our application.",
        isRead: false
      }
];
